// extracted by mini-css-extract-plugin
module.exports = {"row":"SubmitterRow_row__3AAGi","name":"SubmitterRow_name__1jZ-c","count":"SubmitterRow_count__2zI7u","unsubmittedBadge":"SubmitterRow_unsubmittedBadge__2STLE"};